import classNames from 'classnames';

import { LayoutContainer } from '@zooplus/ui-components';

import commonStyles from '../../../styles/common.module.scss';

import { PAGE_LAYOUT } from '@utilities/constants';

import styles from './main-layout-container.module.scss';

const MainLayoutContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <LayoutContainer
      variant="default"
      aria-label={PAGE_LAYOUT.WIDER}
      data-testid={PAGE_LAYOUT.WIDER}
      className={classNames(styles.mainContainer, commonStyles.pageContentWrapper_wideLayout)}>
      {children}
    </LayoutContainer>
  );
};

export default MainLayoutContainer;
